/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {manualDisableYieldForSponsoredAccounts} from '../api'

export const useMutationManualDisableYieldForSponsoredAccounts = createReactQueryMutationHook('manualDisableYieldForSponsoredAccounts', manualDisableYieldForSponsoredAccounts)
